module.exports = __webpack_public_path__ + "static/img/M-615-NOCE.f41cff9.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/M-615-NOCE.png
// module id = vmeR
// module chunks = 0